import React from "react";
import useResponsibleGamingTextByCountry from "../../hooks/useResponsibleGamingTextByCountry";
import PayoutDistributionTable from "../../components/PayoutDistributionTable/PayoutDistributionTable";
import PickXProvincesAndTerritories from "../../components/PickXProvincesAndTerritories/PickXProvincesAndTerritories";
import Pick16PayoutCalculator from "../../services/Pick16ParlayPayoutCalculator";
import Pick12PayoutCalculator from "../../services/Pick12ParlayPayoutCalculator";
import GlobalConst from "../../constants/GlobalConst";

const TermsOfUseEn = () => {
    const responsibleGamingTexts = useResponsibleGamingTextByCountry();

    const host = window.location.origin;

    return (
        <div className="terms-container">
            <h1>TradeFan PickX Terms of Use</h1>
            <p><strong>Last Updated: October 1, 2024</strong></p>
            <br/>
            <p>IMPORTANT! PLEASE CAREFULLY READ THESE TRADEFAN PICKX TERMS OF USE BEFORE USING TRADEFAN PICKX SERVICES,
                AS THESE TERMS AFFECT YOUR LEGAL RIGHTS AND OBLIGATIONS. THE AGREEMENTS (AS DEFINED IN THE INTRODUCTION
                SECTION) ARE SUBJECT TO A WAIVER OF TRIAL BY JURY.</p>
            <br/>
            <section id="introduction">
                <p><strong>INTRODUCTION</strong></p>
                <p>
                    TradeFan PickX is a daily fantasy sports contest format offered by 8710031 Canada Inc.
                    (“<strong>TradeFan</strong>”
                    or “<strong>Company</strong>”) where participants can win by selecting whether or not their chosen athletes will
                    outperform a statistical projection during real-world sporting events (“<strong>Pick Set</strong>”). TradeFan owns
                    and operates the website <a href={host}>{host}</a> (the
                    “Website”) and, once launched, the TradeFan
                    PickX mobile application (“<strong>Mobile Application</strong>,” and the Mobile Application together with the
                    Website, the “<strong>TradeFan Platform</strong>”). These TradeFan PickX Terms of Use (the “<strong>Terms of Use</strong>”) govern all
                    aspects of your access and use of the TradeFan Platform; placing any entries through the TradeFan
                    Platform; and the contests, content, products, features, tools, promotions, and other services
                    offered through the TradeFan Platform (collectively, the “<strong>Services</strong>”).
                </p>
            </section>
            <br/>
            <section id="agreement">
                <p><strong>AGREEMENT TO BE BOUND</strong></p>
                <p>
                    By visiting the Website or downloading the Mobile Application, in each case, regardless of whether
                    or not you create or have an Account (as defined in the Age and Physical Location section below),
                    registering for the Services, and/or using the Services, you agree to be bound by these Terms of
                    Use; TradeFan’ privacy notice available by clicking <a
                    href={host+"/PrivacyPolicy"}>here </a>
                    (the “<strong>Privacy Notice</strong>”); and all other rules, terms and conditions, policies, and notices applicable
                    to the TradeFan Platform, the Services, or any offers, promotions, or bonuses offered on or through
                    the TradeFan Platform or Services that are posted on or through the TradeFan Platform or Services or
                    that are otherwise communicated to you, as may be amended at any time from time to time, and all of
                    which are hereby incorporated by reference into these agreements in their entirety (the “Other
                    Terms”, and together with the Terms of Use, the “Agreements”). The Agreements do not apply to or
                    govern your use of other products and/or services provided by TradeFan or its affiliates, including,
                    without limitation, TradeFan Trading fantasy sports contests.
                </p>
                <p>IN THE EVENT YOU DO NOT AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS OF THE AGREEMENTS
                    WITHOUT MODIFICATION, DO NOT USE OR ACCESS THE TRADEFAN PLATFORM OR THE SERVICES. The Agreements
                    constitute a legal agreement between you and TradeFan and shall apply to your access and use of the
                    TradeFan Platform and the Services, even after closure of your Account, termination of the offering
                    of the Services, or termination of any or all of your rights granted under the Agreements.</p>
            </section>
            <br/>
            <section id="ageLocation">
                <p><strong>AGE AND PHYSICAL LOCATION</strong></p>
                <p>
                    To create an account on the TradeFan Platform (“<strong>Account</strong>”), use the Services, enter and participate
                    in the contests offered through the Services (the “<strong>Contests</strong>”), or receive any prizes from the
                    TradeFan Platform and/or Services, you must be, and affirm that you are, at least eighteen (18)
                    years old. However, if you are physically located in Alabama or Nebraska, you must be at least
                    nineteen (19) years old, or if you are in Arizona or Massachusetts, you must be at least twenty-one
                    (21) years old. It may be considered a criminal or civil offense for any person to use the Services,
                    or for any person to allow others to use the Services, if they do not meet these age requirements.
                </p>
                <p>
                    Only individuals physically located in the jurisdictions listed at TradeFan Platform Where can you
                    play TradeFan Pick6? (“<strong>Eligible Jurisdictions</strong>”) can create an Account and use the Services. These
                    Terms of Use include, by reference, the list of Eligible Jurisdictions available at <a href={host+"/#where-is-PickX-available"}>{host}/#where-is-PickX-available</a>. TradeFan reserves the right to update, change,
                    or modify these webpages or lists of Eligible Jurisdictions at its sole discretion, at any time, and
                    without notice.
                </p>
                <p>
                    If you are located outside of an Eligible Jurisdiction, you may be able to access and view the
                    TradeFan Platform but are prohibited from using the Services, including entering any Contests. If
                    you do use the Services while outside the Eligible Jurisdictions, any actions you take, including
                    entering Contests, are void, and any prizes you may win are invalid. Such prizes will be forfeited
                    and deducted from your Account balance. If you have already withdrawn such forfeited prizes from
                    your Account, you agree to promptly return them when requested.
                </p>
                <p>
                    These Terms of Use govern your access to and use of the TradeFan Platform, including all content,
                    when you access or use TradeFan Platform from outside Eligible Jurisdictions. You also agree to
                    comply with all applicable laws of the jurisdiction in which you are located when accessing and/or
                    using the TradeFan Platform and/or Services.
                </p>
                <p>
                    By accessing or using the Services, you represent, warrant, and covenant that:
                    <ol>
                        <li>
                            <strong>Jurisdictional Compliance: </strong>You are located in a jurisdiction where the use
                            of the Services, including participating in any Contests, is permitted by law, and you have
                            verified that your use of the Services complies with all applicable laws, regulations, and
                            rules in your location.
                        </li>
                        <li>
                            <strong>Legality of Participation: </strong>You further represent and warrant that your use
                            of the Services, including but not limited to accessing the Platform, entering Contests, and
                            receiving any prizes, does not violate any legal restrictions in your jurisdiction,
                            including but not limited to laws relating to gambling, gaming, skill contests, or
                            sweepstakes.
                        </li>
                        <li>
                            <strong>Responsibility for Compliance: </strong>It is your sole responsibility to understand
                            and comply with the laws, rules, and regulations that apply in your jurisdiction. TradeFan
                            does not and will not provide any assurance or guarantee regarding the legality of your
                            participation in the Services in any jurisdiction.
                        </li>
                        <li>
                            <strong>Access Restrictions: </strong>If at any time it is determined that you have accessed
                            or used the Services from a jurisdiction where such access or use is prohibited, or if
                            TradeFan determines, in its sole discretion, that you are in violation of applicable law or
                            these Agreements, TradeFan reserves the right to immediately suspend or terminate your
                            Account and access to the Services without notice, and you agree to forfeit any prizes or
                            benefits that may have been earned.
                        </li>
                        <li>
                            <strong>Proof of Eligibility: </strong>Upon request by TradeFan, you agree to provide proof
                            of your compliance with the laws and regulations of your jurisdiction, including
                            documentation showing your physical location and any licenses or authorizations that may be
                            required.
                        </li>
                    </ol>
                </p>
            </section>
            <br/>
            <section id="account">
                <p><strong>YOUR ACCOUNT</strong></p>
                <p>
                    TradeFan reserves the right to refuse your request to open an Account at its sole discretion, for
                    any reason or no reason at all. When you create an Account or use the Services, you may be required
                    to provide specific information, including but not limited to your full legal name, date of birth,
                    social security number, other tax identification number, physical address, email address, and any
                    other details or documentation needed to verify your identity and eligibility. If TradeFan requests
                    additional information from you, you must promptly supply accurate and complete details, and you are
                    responsible for updating them as needed. TradeFan may request more information or documentation at
                    any time, at its discretion, including before you enter a Contest, make a deposit or withdrawal, or
                    claim a prize. This is done to verify your identity and ensure you meet the eligibility criteria.
                </p>
                <p>
                    Until you provide the requested information, or if you fail to do so promptly, TradeFan may, without
                    limitation, withhold prizes, restrict your ability to make deposits or withdrawals, suspend your
                    Account, or even close it. You agree to allow TradeFan to verify your age and identity. In case of
                    any questions, disputes, or concerns about your identity or eligibility, TradeFan may use certain
                    information collected from you at its discretion to help verify these details.
                </p>
                <p>
                    You are allowed to create only one Account. You may not use or access someone else’s Account, with
                    or without their consent, nor may you allow anyone to use or access your Account. This includes, but
                    is not limited to, entering Contests on behalf of someone else, using another person’s Account for
                    Contests, accessing another individual’s Pick Set, Contest, or Account information, or letting
                    someone else do any of these with your Account. If TradeFan believes, for any reason, that you have
                    opened more than one Account, allowed someone else to access your Account, or are using someone
                    else’s Account, TradeFan reserves the right to suspend or terminate any or all of your Accounts. It
                    can also cancel any pending Contest entries or withhold, revoke, or terminate any prizes awarded to
                    you.
                </p>
                <p>
                    These Terms of Use also apply if you access someone else’s Account, even if you do not have your
                    own. Such access will be considered a violation of the Terms. You may not open an Account on behalf
                    of anyone else, particularly if that person is prohibited by law or by these Terms from opening an
                    Account or using the Services.
                </p>
                <p>
                    By using the Services, you agree that TradeFan, its affiliates, and third-party service providers
                    may monitor and record your communications and geographic location. You also consent to TradeFan
                    reporting your Account activity or prize winnings to applicable state, federal, and local
                    authorities, in compliance with relevant laws.
                </p>
            </section>
            <br/>
            <section id="loginPassword">
                <p><strong>ACCOUNT LOGIN AND PASSWORD</strong></p>
                <p>
                    You are responsible for keeping your Account login name and password confidential and must not share
                    them with anyone. You agree to make every effort to protect your login details, including using a
                    unique password for your Account and disabling any browser options that store or autofill passwords.
                    You should also change your password regularly, and you can find instructions for doing so [here].
                    Additionally, you must lock the device(s) you use to access the TradeFan Platform.
                </p>
                <p>
                    You are responsible for all actions, charges, and damages that occur under your Account, whether
                    authorized by you or not. If you believe someone else is using your Account, contact us immediately
                    at support@TradeFan.com. TradeFan is not liable for any losses, charges, or damages due to
                    unauthorized access to your Account or your failure to notify us of such unauthorized access,
                    regardless of whether you were aware of it.
                </p>
                <p>
                    You agree to indemnify and hold TradeFan, its parent companies, subsidiaries, affiliates,
                    successors, assigns, officers, directors, employees, agents, contractors, shareholders, and
                    representatives (collectively, the “TradeFan Released Parties”) harmless from any claims, legal
                    actions, liabilities, costs, losses, and expenses (including attorneys’ fees, court costs, and other
                    legal expenses). This includes costs arising from trials, appeals, or bankruptcy proceedings, as
                    well as any damages resulting from third-party access to your Account, whether that access was
                    authorized or not, and whether due to your violation of laws, negligence, willful actions, or breach
                    of these Agreements.
                </p>
            </section>
            <br/>
            <section id="deposits">
                <p><strong>DEPOSITS</strong></p>
                <p>
                    Your Account can be funded through various deposit methods, depending on where you are physically
                    located when making the deposit. TradeFan accepts major debit cards and, depending on your location,
                    may also accept major credit cards.
                </p>
                <p>
                    You confirm that you are the legal owner of the payment method used for deposits and withdrawals and
                    that the funds are not connected to any illegal activity. Using a payment method that you do not
                    legally own, or depositing funds linked to illegal activity violates these Terms of Use.
                </p>
                <p>
                    You agree not to reverse (or “charge back”) any deposits made into your Account, including via third
                    parties. If any deposits are charged back, canceled, fail to clear, or are not honored by your
                    financial institution, TradeFan may immediately restrict your Account access. Any prizes, rewards,
                    credits, or bonuses related to these deposits will be invalidated and deducted from your Account
                    balance. You also agree to return any funds you withdrew that are associated with a canceled or
                    charged-back deposit.
                </p>
                <p>
                    If your deposit is charged back or canceled, or doesn’t clear, TradeFan reserves the right to (i)
                    deduct the deposit amount from your Account, (ii) suspend or close your Account, and/or (iii)
                    recover the funds by any other means, such as using a collection agency (which may negatively affect
                    your credit score). You are responsible for reimbursing TradeFan for any costs, fees, or penalties
                    related to chargebacks or canceled deposits, including legal fees and expenses for collection
                    efforts.
                </p>
                <p>
                    If you believe your funds have been mishandled, you can file a complaint by emailing
                    <a href="mailto:support@TradeFan.com" > support@TradeFan.com</a> . TradeFan will try to respond to your complaint within ten (10) business days.
                    If the complaint is not resolved in your favor, TradeFan will explain the reasons. If more
                    information is needed to process your complaint, TradeFan will inform you of the additional details
                    required.
                </p>
            </section>
            <br/>
            <section id="conditionsParticipation">
                <p><strong>CONDITIONS OF PARTICIPATION</strong></p>
                <p>
                    You are not allowed to use the TradeFan Platform or its services, including entering contests, if
                    any of the following apply:
                </p>
                <ul>
                    <li>The laws, rules, regulations, or other authorized acts of the jurisdiction in which you are
                        physically located don’t allow you to use the Services.
                    </li>
                    <li>Your usage breaks the rules of the TradeFan Platform.</li>
                    <li>You have accessed confidential or pre-release information that gives you an unfair advantage,
                        like knowing the outcome of events or private details from a sports governing body.
                    </li>
                    <li>You or an immediate family member (someone living with you, like a partner, parent, or sibling)
                        (an “Immediate Family Member”) works for a fantasy sports company or a similar site that offers
                        entry fees or prizes.
                    </li>
                    <li>You are on a state exclusion list for daily fantasy sports or gaming.</li>
                    <li>TradeFan decides that your participation undermines the fairness of any contest.</li>
                    <li>Your participation violates any rules set by your employer or sports organization, like rules
                        about accepting prizes.
                    </li>
                    <li>A court or regulatory body has prohibited you from using the service, or using it would break
                        any laws or regulations in your area
                    </li>
                </ul>
                <p>
                    You cannot use the TradeFan Platform or services for any game, match, or event managed by a sports
                    organization you are connected with if you are an athlete, player, agent, coach, referee, team
                    owner, or any other official (like a doctor or trainer) working with the team. This also applies if
                    you’re an employee, consultant, contractor, or an Immediate Family Member of any of these
                    individuals.
                </p>
                <p>
                    TradeFan employees and their Immediate Family Members are not allowed to participate in public
                    contests (except for testing purposes). However, they are allowed to play in private contests,
                    including those organized by TradeFan, for cash or other prizes. A ‘Private Contest’ is one that is
                    not publicly listed on the TradeFan platform and is hosted by another TradeFan employee or their
                    family, friends, or relatives.
                </p>
                <p>
                    TradeFan can suspend your account, remove you from contests, withhold prizes, or ask for prizes back
                    if they find or believe that you violated their rules. They have the final say on this and don’t
                    need a specific reason. Violations include:
                </p>
                <ul>
                    <li>Committing fraud, like manipulating Contests or Pick Sets, cheating, financial fraud, or
                        unauthorized credit use.
                    </li>
                    <li>Acting in a way that is unfair, harmful to TradeFan’s Services, or negative for other users.
                    </li>
                    <li>Doing anything that damages TradeFan’s reputation or harms their business.</li>
                    <li>Trying to influence the results of games or Contests unfairly, whether alone or with others.
                    </li>
                    <li>Working with others to manipulate Pick Sets or Contests.</li>
                    <li>Using automated tools like bots or scripts to interact with the TradeFan Platform, enter
                        contests, or collect data.
                    </li>
                    <li>Taking advantage of delays in updating information or stats.</li>
                    <li>Using the TradeFan Platform for anything other than personal use or sharing it with others for
                        commercial purposes.
                    </li>
                    <li>Abusing bonuses, referral programs, or promotions.</li>
                    <li>Exploiting obvious mistakes or bugs in the system.</li>
                    <li>Tampering with, bypassing, or manipulating TradeFan’s systems, security, or risk controls.</li>
                    <li>Collecting information from other users for any purpose.</li>
                </ul>
            </section>
            <br/>
            <section id="contestEntry">
                <p><strong>CONTEST ENTRY</strong></p>
                <p>It’s important that you read and understand the rules and procedures for any contest you join. These
                    rules, including any updates made to them, are hereby incorporated in their entirety into these
                    Terms of Use by reference. You can find more details under the Contest Rules tab on the contest’s
                    page or in the TradeFan PickX section of the Help Center/FAQ. hereby incorporated in their entirety
                    into these Terms of Use by reference, including any amendments made at any time. TradeFan and its
                    related parties are not responsible if you join a contest without fully understanding the rules and
                    procedures.</p>
                <p>
                    Participation in each Contest must be made only as specified in the Agreements. TradeFan Pick-X is a
                    contest where participants can win by selecting whether or not their chosen athletes will outperform
                    a statistical projection during real-world sporting events. In Pick-X, participants can build
                    lineups of between 3 and 8 players. Enter your picks to compete in contests and win cash prizes by
                    getting the required amount of picks correct. After creating your Pick Set, you’ll need to enter the
                    total entry fee you’d like to play for. You can do this by typing the total dollar amount directly.
                    Entry fees must be in whole dollar amounts. When you’re ready, proceed to the finalize screen to
                    review your Pick Set and the estimated prize amounts before submitting.
                </p>
                <p>
                    Pick Sets are created by choosing bets from a selection of available options. Before finalizing a
                    Pick Set, TradeFan will check to ensure that all the games included have not yet begun. If any of
                    the games have already started, the Pick Set will not be activated. Each Pick Set must include
                    players from two different teams. You can only select a player once, and you must make picks from
                    players on at least two (2) different teams. Once a player is chosen, they cannot be picked again on
                    the same Pick Set. Once the Pick Set has been submitted, entries may not be edited nor
                    withdrawn.
                </p>
                <p>
                    TradeFan may refuse to accept any Contest entry, any portion of a Contest entry, prohibit you from
                    entering any Contest, or prohibit you from using the TradeFan Platform or the Services, in each
                    case, for any reason or no reason, in TradeFan’s sole and absolute discretion. Additionally, prior
                    to a Contest starting, TradeFan may cancel any Contest(s) and/or any selections made available to
                    create your Pick Set in TradeFan’s sole and absolute discretion, for any reason or no reason.
                </p>
                <p>In the event your Pick Set is successfully entered into a Contest(s), for each Contest your Pick Set
                    is successfully entered into, one U.S. dollar ($1.00) will be debited from your Account balance. In
                    the event you have insufficient funds in your Account, including, without limitation, if a deposit
                    has not been received by TradeFan before the Contest entry is placed (e.g., a deposit is still being
                    processed by the payment processor), such entry may be voided by TradeFan in its sole and absolute
                    discretion, for any reason or no reason. A Contest entry is not valid until the Contest entry is
                    accepted by TradeFan’s servers, even in the event such entry appears in your My Picks. You are
                    responsible to ensure all the details and selections of your Pick Set and Contest entry are complete
                    and correct prior to submitting.</p>
                <p>
                    Picks are only eligible to be scored as Correct if the selected player meets the minimum play
                    requirements, regardless of whether you select Over or Under for that pick.
                </p>
                <p>
                    If a player is not expected to play, TradeFan may make that player unavailable for selection. If a
                    player does not end up playing, their selections will be graded as voided picks, your Pick Set will
                    be void, and your entry fee for that Pick Set will be reimbursed.
                </p>
                <p>
                    If you enter a Contest under suspicious circumstances, as determined by TradeFan at its sole and
                    absolute discretion, for any reason or no reason, such as violating the Agreements, entering too
                    many Contests, making interconnected Pick Set selections, or entering Contests in an unusual
                    pattern, TradeFan may suspend your Account, void your Contest entries, or withhold prizes. You agree
                    to promptly provide any information or cooperation requested by TradeFan in investigating suspicious
                    activities. If you fail to do so, you agree to forfeit and return all associated prizes.
                </p>
                <p>
                    By entering a Contest or using the Services or TradeFan Platform, you agree to follow TradeFan’s
                    decisions, which are made at its sole and absolute discretion, for any reason or no reason, and are
                    final. You understand you have no inherent right to use the TradeFan Platform or Services and that
                    TradeFan can suspend or terminate your Account at any time, for any reason. TradeFan may refuse your
                    use of the TradeFan Platform, Services, or any specific Service, and may refuse Contest entries, at
                    its sole and absolute discretion. If you engage in conduct TradeFan deems improper, fraudulent,
                    suspicious, cheating, dishonest, or unfair, TradeFan can suspend or terminate your Account, void
                    entries, withhold prizes, or require prize returns. TradeFan Released Parties are not liable for
                    these actions, nor do they prevent TradeFan from pursuing legal action.
                </p>
                <p>
                    IF A CONTEST CANNOT PROCEED AS PLANNED DUE TO TECHNICAL PROBLEMS, TAMPERING, FRAUD, OR OTHER CAUSES,
                    TRADEFAN, AT ITS SOLE AND ABSOLUTE DISCRETION, MAY CANCEL, TERMINATE, MODIFY, OR SUSPEND THE
                    CONTEST. ANY ATTEMPT TO DAMAGE THE WEBSITE OR UNDERMINE THE LEGITIMATE OPERATION OF A CONTEST MAY
                    VIOLATE LAWS, AND TRADEFAN RESERVES THE RIGHT TO PURSUE DAMAGES AND OTHER REMEDIES TO THE FULLEST
                    EXTENT PERMITTED BY LAW.
                </p>
            </section>
            <br/>
            <section id="contestWithdrawal">
                <p><strong>CONTEST WITHDRAWAL</strong></p>
                <p>
                    You may be able to withdraw from Contests under certain circumstances, as determined by TradeFan in
                    its sole and absolute discretion, for any reason or no reason. For more information on withdrawing
                    from Contests and when withdrawal from Contests will and will not be permitted, please see the
                    TradeFan PickX section of the TradeFan Help Center available by clicking <a href="/help">here</a>, which is hereby
                    incorporated in its entirety into these Terms of Use by reference, including any amendments made at
                    any time.
                </p>
            </section>
            <br/>
            <section id="limitationResposibilities">
                <p><strong>LIMITATION OF TRADEFAN RESPONSIBILITIES</strong></p>
                <p>
                    The TradeFan Released Parties (as defined herein) are not responsible for any incorrect, invalid, or
                    inaccurate information; incomplete, incorrect, illegible, unintended, or misdirected entries; human
                    errors; postal delays or postage due mail; technical malfunctions or failures, such as public
                    utility, telephone, or Internet outages; omissions, interruptions, deletions, or defects in
                    telephone or Internet systems, computer systems, data, servers, providers, or software (including
                    software or operating systems that prevent you from using the TradeFan Platform or entering a
                    Contest); any damage to your or another person’s computer or equipment due to use of the TradeFan
                    Platform or Services; inability to access or use the Services or any web pages related to the
                    Website or TradeFan Platform; issues like theft, tampering, or unauthorized access to or changes to
                    the TradeFan Platform or your Account; data being processed late, incorrectly, or lost due to
                    telephone, Internet, or postal issues, computer malfunctions, or traffic congestion; or any
                    typographical, printing, or similar errors.
                </p>
                <p>
                    TradeFan, at its sole and absolute discretion, can suspend or terminate any Services, Contests, or
                    the TradeFan Platform, as well as suspend your access, terminate your Account, void Contest entries,
                    withhold prizes, or require the return of prizes or funds credited to your Account in error, even if
                    you’ve already withdrawn them, for any reason or no reason. This may happen if:
                </p>
                <ul>
                    <li>There’s an obvious error with a Contest, such as incorrect stats or if the event has already
                        started or occurred.
                    </li>
                    <li>A selection is incorrectly scored in your favor.</li>
                    <li>Funds are credited to your Account in error.</li>
                    <li>A virus, bug, tampering, or technical failure stops the TradeFan Platform or Services from
                        working properly or affects the fairness and integrity of the TradeFan Platform, Contests, or
                        Services.
                    </li>
                </ul>
                <p>
                    You must immediately inform TradeFan and stop using the Services and Platform if you become aware of
                    any errors related to the Services, Platform, Contests, or your Account, including funds credited to
                    your Account by mistake. Any amounts or prizes credited to your Account by mistake are held in trust
                    for TradeFan and must be returned upon request, even if you’ve already withdrawn them. TradeFan also
                    reserves the right to reclaim any mistakenly credited funds or prizes directly from your Account.
                </p>
                <p>
                    ANY ATTEMPT BY YOU OR ANY OTHER PERSON TO DAMAGE THE TRADEFAN PLATFORM OR SERVICES OR UNDERMINE
                    THEIR LEGITIMATE OPERATION IS A VIOLATION OF THESE TERMS OF USE AND MAY ALSO VIOLATE CRIMINAL AND/OR
                    CIVIL LAWS. IF SUCH AN ATTEMPT IS MADE, TRADEFAN RESERVES THE RIGHT TO SEEK DAMAGES AND OTHER
                    REMEDIES TO THE FULLEST EXTENT OF THE LAW.
                </p>
                <p>
                    You may only use the TradeFan Platform and Services as specified in the Agreements. Failure to
                    comply with the Agreements may result, without limitation, in suspension and/or termination of your
                    Account, the voiding or cancelation of any pending Contest entries, withholding of any prizes,
                    and/or the return of any prizes.
                </p>
            </section>
            <br/>
            <section id="howPick12Works">
                <p><strong>HOW DOES A PICK-12 CONTEST WORK?</strong></p>
                <p>
                    Answer correctly as many of the 12 over/under questions, and refer to the following prize scheme to
                    claim the prize corresponding to your score:
                </p>
                <PayoutDistributionTable payoutInfos={new Pick12PayoutCalculator().calculateDistribution(5)}
                                         currency={GlobalConst.SITE_CURRENCY}/>
            </section>
            <br/>
            <section id="howPick16Works">
                <p><strong>HOW DOES A PICK-16 CONTEST WORK?</strong></p>
                <p>
                    Answer correctly as many of the 16 over/under questions, and refer to the following prize scheme to
                    claim the prize corresponding to your score:
                </p>
                <PayoutDistributionTable payoutInfos={new Pick16PayoutCalculator().calculateDistribution(5)}
                                         currency={GlobalConst.SITE_CURRENCY}/>
            </section>
            <br/>
            <section id="grantOfLicense">
                <p><strong>GRANT OF LICENSE</strong></p>
                <p>
                    Except where prohibited by law, by using the Services or TradeFan Platform, entering any Contests,
                    or accepting any prize, you grant TradeFan and its affiliates the worldwide, perpetual, irrevocable,
                    enterprise wide, royalty-free right to use your name, username, photograph, likeness, statements,
                    biographical information, voice, city and state of residence, and other identifying information in
                    any and all forms of media, now known or hereafter devised, for advertising and promotional purposes
                    related to the TradeFan Platform, the Services, TradeFan or its affiliates, and/or TradeFan and
                    TradeFan’ affiliates’ other products and services without any additional consideration,
                    compensation, notification, review, approval, or permission. You hereby agree to sign any publicity
                    release required by TradeFan.
                </p>
            </section>
            <br/>
            <section id="promotions">
                <p><strong>PROMOTIONS</strong></p>
                <p>
                    Except where prohibited by law, by using the Services or TradeFan Platform, entering any Contests,
                    or accepting any prize, you grant TradeFan and its affiliates the worldwide, perpetual, irrevocable,
                    enterprise wide, royalty-free right to use your name, username, photograph, likeness, statements,
                    biographical information, voice, city and state of residence, and other identifying information in
                    any and all forms of media, now known or hereafter devised, for advertising and promotional purposes
                    related to the TradeFan Platform, the Services, TradeFan or its affiliates, and/or TradeFan and
                    TradeFan’ affiliates’ other products and services without any additional consideration,
                    compensation, notification, review, approval, or permission. You hereby agree to sign any publicity
                    release required by TradeFan.
                </p>
                <p>
                    The Agreements apply to any promotions, bonuses, achievements, or similar offers related to the
                    Services and/or TradeFan Platform. Each promotion, bonus, mission, or similar offer may come with
                    additional terms, conditions, rules, and/or eligibility requirements. These will either (i) be
                    posted on the TradeFan Platform and/or Services and will immediately become binding, whether or not
                    they are directly communicated to you, or (ii) be otherwise communicated to you. These additional
                    terms, conditions, rules, and/or eligibility requirements are fully incorporated into these Terms of
                    Use by reference, including any future changes to them.
                </p>
                <p>
                    By participating in any promotions, bonuses, achievements, or similar offers, or by claiming or
                    accepting any prize or reward, you agree to all terms, conditions, rules, and/or eligibility
                    requirements of that offer, which are also incorporated into these Terms of Use by reference,
                    including any amendments. If you do not agree with the terms, conditions, rules, and/or eligibility
                    requirements, do not participate or accept any prizes or rewards.
                </p>
                <p>
                    In case of any conflict between these Agreements and the separate terms for a specific promotion,
                    bonus, achievement, or similar offer, the specific terms of the promotion or offer will govern.
                    Nothing in the Agreements will change or invalidate those separate terms.
                </p>
                <p>
                    TradeFan reserves the right to prevent you from participating in any promotion, bonus, achievement,
                    or similar offer for any reason, or no reason, at its sole and absolute discretion. You are fully
                    responsible for reading and understanding the terms, conditions, and requirements for any promotion
                    you participate in.
                </p>
            </section>
            <br/>
            <section id="responsibleGaming">
                <p><strong>RESPONSIBLE GAMING</strong></p>
                <p>
                    Information about responsible gaming, including self-exclusion and self-limitation options, is
                    available at: <a href={`${responsibleGamingTexts.link}`}>{responsibleGamingTexts.title}</a>
                </p>
            </section>
            <br/>
            <section id="statisticsAndLiveScoring">
                <p>
                    All statistics, results, news, and other information provided on the TradeFan Platform or Services,
                    including “live” statistics, are unofficial, may not be up to date, and are provided AS IS for
                    informational and entertainment purposes only. You should not rely on these statistics, results,
                    news, or other information for any purposes, including making Contest or Pick Set decisions. These
                    statistics and results may also differ from the official ones used to determine the outcome of Pick
                    Set selections and/or Contests.
                </p>
                <p>
                    Neither the TradeFan Released Parties nor any third-party providers make any guarantees or
                    representations about the accuracy or reliability of the statistics, results, news, or other
                    information provided through the TradeFan Platform, Services, or related sources. The TradeFan
                    Released Parties and third-party providers are not responsible for the accuracy, usefulness, or
                    availability of this information and will not be held responsible for any errors or omissions in the
                    statistics, news, results, or other information provided.
                </p>
            </section>
            <br/>
            <section id="results">
                <p><strong>RESULTS</strong></p>
                <p>
                    Contests offered through the Services and/or TradeFan Platform are contests of skill. Winners are
                    determined based on the participant’s skill and knowledge, including, without limitation, with
                    respect to relevant sports information and Contest rules. The Services, TradeFan Platform, and/or
                    Contests may not be used for any form of illicit gambling.
                </p>
                <p>
                    Contests are scored based on the number of correct selections in your Pick Set for that Contest.
                    Contests results are based on the final statistics and scoring at the completion of the applicable
                    game(s), contest(s), match(s), or event(s) associated with the Contest. Upon completion of the last
                    game, contest, match, or event associated with the Contest, results are reviewed, entries are
                    graded, and any prizes are awarded. Final scoring results and statistics will not be changed,
                    regardless of any official statistics or scoring adjustments made at later times, except in
                    TradeFan’ sole and absolute discretion, for any reason or no reason. In the event a game(s),
                    contest(s), match(s), or event(s) associated with a Contest is canceled, postponed, or rescheduled,
                    for purposes of the Contest, such cancellation, postponement, or rescheduling shall be treated in
                    accordance with the Contest Rules for the applicable Contest (available in the Contest Rules tab of
                    the applicable Contest’s Details page) which are hereby incorporated in their entirety into these
                    Terms of Use by reference, including any amendments made at any time.
                </p>
            </section>
            <br/>
            <section id="paymentAndWithdrawal">
                <p><strong>PAYMENT AND WITHDRAWAL</strong></p>
                <p>
                    Before giving you any prizes, TradeFan may ask you to complete an affidavit confirming your
                    eligibility and releasing TradeFan from any claims. You also need to confirm you are eligible to use
                    the Services, follow the Agreements, and provide documentation proving your identity and
                    eligibility, including completing tax forms. If TradeFan asks for this and you don’t provide it
                    within seven (7) days, or if TradeFan decides you don’t meet the requirements or are not following
                    the Agreements, they can withhold or take back any prizes, and they may suspend or terminate your
                    Account and access to the Services.
                </p>
                <p>
                    Subject to TradeFan verifying your compliance with the Agreements and any other conditions of
                    participation, winnings for your Pick Set will process after both of the following have occurred:
                </p>
                <ol>
                    <li>
                        Each game in the Pick Set is complete, which may include games that you do not have picks for;
                        and
                    </li>
                    <li>
                        TradeFan has finalized the stats for each game in the Pick Set to confirm their accuracy with
                        the official scoring from the respective leagues, typically at the end of the night.
                    </li>
                </ol>
                <p>
                    Due to this, there may be time between when your picks have all gone final and when any winnings
                    process to your account.
                </p>
                <p>
                    All taxes associated with the receipt of any prizes are the sole responsibility of the winner.
                    TradeFan may report prizes to the applicable state agency and/or Internal Revenue Service and/or
                    withhold a portion of your prize(s) based on the gross or net amount won. TradeFan will remit any
                    portion of your prize(s) withheld for tax purposes to the Internal Revenue Service and/or the
                    applicable state agency in compliance with applicable law.
                </p>
                <p>
                    To update your contact information, you may edit it within your Account or request changes by
                    emailing <a href='mailto:support@TradeFan.com'>support@TradeFan.com</a>
                </p>
                <p>
                    In the event the awarding of any prize is challenged by any legal authority, TradeFan reserves the
                    right to determine, in its sole and absolute discretion, for any reason or no reason, whether or not
                    to award such prize. In the event you win an amount or prize over a certain value, and you owe
                    certain amounts to the state, including, without limitation, child support arrearages or unpaid
                    taxes, TradeFan may suspend your Account, prevent you from making withdrawals from your Account,
                    and/or withhold and remit any prizes, or portion thereof, in accordance with applicable law. No
                    substitution or transfer of any prize is permitted, except that TradeFan reserves the right, in its
                    sole and absolute discretion, for any reason or no reason, to substitute a prize of equal or greater
                    value. All prizes are awarded “as is” and without warranty of any kind, express or implied,
                    including, without limitation, any implied warranty of merchantability or use for a particular
                    purpose.
                </p>
            </section>
            <br/>
            <section id="termination">
                <p><strong>TERMINATION AND EFFECT OF TERMINATION</strong></p>
                <p>
                    You can permanently close your Account at any time for any reason by e-mailing <a
                    href='mailto:support@TradeFan.com'>support@TradeFan.com</a>
                </p>
                <p>
                    TradeFan may immediately suspend or terminate the Services, Contests, TradeFan Platform, or any
                    features or functions within the Services or Platform at any time, without prior notice, at its sole
                    and absolute discretion, for any reason or no reason. If TradeFan ends the Services, they may refund
                    your Account balance minus any unused bonuses, free entries, or promotional credits, which will be
                    forfeited.
                </p>
                <p>
                    In addition, TradeFan may, without prior notice and at its sole discretion, for any reason or no
                    reason, close your Account, disable your password(s), deny you access to the TradeFan Platform and
                    Services, cancel any pending Contest entries, and/or terminate any rights granted under the
                    Agreements. If this happens, you must immediately stop using the TradeFan Platform and Services. The
                    TradeFan Released Parties are not responsible for any suspension or termination of Services,
                    Contests, the TradeFan Platform, or any features, or for the termination or suspension of your
                    Account.
                </p>
                <p>
                    Closing your Account or terminating the Services, Contests, or Platform, or any rights granted under
                    the Agreements, does not affect any rights, obligations, or liabilities that arose before that. All
                    parts of the Agreements that should continue after closure of your Account or termination of the
                    Services or rights, such as ownership provisions, warranty disclaimers, indemnity, and limitation of
                    liability, will remain in effect.
                </p>
            </section>
            <br/>
            <section id="disclaimer">
                <p><strong>DISCLAIMER OF WARRANTIES</strong></p>
                <p>
                    ALL CONTENT, SOFTWARE, AND FEATURES ON THE TRADEFAN PLATFORM, CONTESTS, AND SERVICES ARE PROVIDED
                    “AS IS,” “AS AVAILABLE,” AND “WITH ALL FAULTS.” YOUR USE OF THE TRADEFAN PLATFORM AND ENTRY INTO ANY
                    CONTESTS IS AT YOUR OWN RISK. TRADEFAN RELEASED PARTIES DISCLAIM ANY AND ALL WARRANTIES, WHETHER
                    EXPRESS OR IMPLIED, INCLUDING NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                    AND TITLE.
                </p>
                <p>
                    TRADEFAN RELEASED PARTIES MAKE NO GUARANTEES ABOUT:
                </p>
                <ul>
                    <li>THE INTELLECTUAL PROPERTY, PLATFORM, CONTESTS, OR SERVICES.</li>
                    <li>THE ACCURACY OR COMPLETENESS OF THE CONTENT AND SOFTWARE ON THE TRADEFAN PLATFORM OR SERVICES.
                    </li>
                    <li>THE FUNCTIONALITY OF THE TRADEFAN PLATFORM OR SERVICES.</li>
                    <li>MESSAGES OR INFORMATION SENT THROUGH THE TRADEFAN PLATFORM OR BY OTHER USERS.</li>
                    <li>ANY PRODUCTS OR SERVICES OFFERED THROUGH THE TRADEFAN PLATFORM, INCLUDING THIRD-PARTY
                        PRODUCTS.
                    </li>
                    <li>LINKS TO THIRD-PARTY WEBSITES OR APPS.</li>
                    <li>THE SECURITY OF ANY SENSITIVE INFORMATION TRANSMITTED THROUGH THE TRADEFAN PLATFORM OR SERVICES,
                        OR TO THIRD-PARTY SITES LINKED TO IT.
                    </li>
                </ul>
                <p>
                    TRADEFAN DOES NOT GUARANTEE THAT THE TRADEFAN PLATFORM OR SERVICES WILL BE UNINTERRUPTED,
                    ERROR-FREE, ALWAYS AVAILABLE, OR FREE OF VIRUSES OR HARMFUL ELEMENTS, OR THAT DEFECTS WILL BE FIXED.
                </p>
                <p>
                    TRADEFAN RELEASED PARTIES ARE NOT RESPONSIBLE FOR WHETHER YOUR USE OF THE TRADEFAN PLATFORM OR
                    PARTICIPATION IN CONTESTS IS LEGAL IN YOUR LOCATION. YOU ARE RESPONSIBLE FOR ENSURING THAT YOUR
                    ACTIVITIES ARE LEGAL WHERE YOU USE THE TRADEFAN PLATFORM OR SERVICES, AND YOU DO SO AT YOUR OWN
                    RISK.
                </p>
            </section>
            <section id="indemnification">
                <p><strong>INDEMNIFICATION</strong></p>
                <p>
                    By using the TradeFan Platform, entering a Contest, using the Services, or accepting any prizes, you
                    agree to indemnify, release, and hold harmless the TradeFan Released Parties from any liability,
                    claims, damages, losses, costs, or expenses (including attorneys’ fees, court costs, and legal
                    expenses) resulting from: (i) your participation in Contests or use of the Services or TradeFan
                    Platform, including travel to or participation in events or activities related to the TradeFan
                    Platform; (ii) your receipt, ownership, use, or misuse of any prize, and your or your guests’
                    attendance at any prize event, including travel to or from such events; (iii) your breach of the
                    Agreements; (iv) your use of the Services or TradeFan Platform in violation of any laws or
                    regulations; (v) any funding of your Account, including the payment method used; (vi) your use of
                    the TradeFan Platform, Services, or Intellectual Property in a way that violates or infringes on
                    third-party rights, including patents, copyrights, trademarks, publicity rights, or privacy rights;
                    (vii) your rights of publicity or privacy; and (viii) any information you submit to TradeFan,
                    including false or misleading information or misrepresentations.
                </p>
                <p>
                    These are referred to as “Indemnification Claims.” TradeFan reserves the right to control the
                    defense or settlement of any Indemnification Claims without your consent. You agree to cooperate and
                    provide any information or assistance requested by TradeFan during the defense or settlement of
                    these claims. You also agree not to settle any Indemnification Claims or make any statements that
                    might affect TradeFan’s defense without their prior written consent.
                </p>
            </section>
            <br/>
            <section id="limitationLiability">
                <p><strong>LIMITATION OF LIABILITY</strong></p>
                <p>YOU UNDERSTAND AND AGREE THAT THE TRADEFAN RELEASED PARTIES LIMIT THEIR LIABILITY FOR YOUR
                    PARTICIPATION IN CONTESTS OR USE OF THE SERVICES AND TRADEFAN PLATFORM, REGARDLESS OF WHETHER THE
                    ISSUE IS DUE TO CONTRACT, NEGLIGENCE, STRICT LIABILITY, OR TORT (INCLUDING CAUSES LIKE NEGLIGENCE,
                    ACTS OF GOD, TELECOM FAILURES, OR THEFT). THE TRADEFAN RELEASED PARTIES ARE NOT RESPONSIBLE FOR ANY
                    LOSSES OR DAMAGES OF ANY KIND, INCLUDING SPECIAL, DIRECT, INDIRECT, INCIDENTAL, OR PUNITIVE DAMAGES,
                    THAT ARE RELATED TO:
                </p>
                <ol>
                    <li>THE TRADEFAN PLATFORM, SERVICES, CONTESTS, INTELLECTUAL PROPERTY, OR ANY CONTENT ON THE TRADEFAN
                        PLATFORM.
                    </li>
                    <li>THE USE, INABILITY TO USE, OR PERFORMANCE OF THE SERVICES OR PLATFORM, INCLUDING CONTESTS.</li>
                    <li>ANY ACTIONS TAKEN BY TRADEFAN OR LAW ENFORCEMENT REGARDING YOUR PARTICIPATION IN CONTESTS OR USE
                        OF THE TRADEFAN PLATFORM OR SERVICES.
                    </li>
                    <li>ACTIONS TAKEN IN CONNECTION WITH COPYRIGHT CLAIMS.</li>
                    <li>ANY ERRORS OR ISSUES IN THE CONTESTS OR TECHNICAL OPERATION OF THE TRADEFAN PLATFORM OR
                        SERVICES.
                    </li>
                </ol>
                <p>
                    EVEN IF THESE DAMAGES WERE FORESEEABLE OR TRADEFAN RELEASED PARTIES WERE WARNED ABOUT THE
                    POSSIBILITY
                    OF SUCH DAMAGES, THEY STILL ARE NOT LIABLE. SOME STATES MAY NOT ALLOW THIS LIMITATION ON DAMAGES, SO
                    IT MIGHT NOT APPLY TO YOU. IN ANY CASE, THE MAXIMUM LIABILITY OF TRADEFAN RELEASED PARTIES FOR ALL
                    CLAIMS WILL NOT EXCEED $100.
                </p>
                <p>
                    YOU ALSO AGREE TO WAIVE YOUR RIGHT TO A JURY TRIAL FOR ANY CLAIMS.
                </p>
                <p>
                    IF YOU ARE UNHAPPY WITH THE TRADEFAN PLATFORM OR SERVICES, YOUR ONLY OPTION IS TO STOP USING THEM.
                    IF YOU SUFFER DAMAGES OR LOSSES DUE TO TRADEFAN RELEASED PARTIES’ ACTIONS, THESE ARE NOT SEVERE
                    ENOUGH TO JUSTIFY PREVENTING TRADEFAN FROM CONTINUING ITS BUSINESS OPERATIONS, INCLUDING ANY
                    DEVELOPMENT, PRODUCTION, OR DISTRIBUTION OF ITS SERVICES OR PRODUCTS.
                </p>
                <p>
                    BY ENTERING CONTESTS OR USING THE TRADEFAN PLATFORM OR SERVICES, YOU UNDERSTAND THAT YOU MAY BE
                    WAIVING RIGHTS RELATED TO CLAIMS THAT ARE CURRENTLY UNKNOWN. YOU AGREE TO WAIVE THE BENEFITS OF ANY
                    LAW (LIKE CALIFORNIA CIVIL CODE SECTION 1542 OR ANY SIMILAR OR EQUIVALENT LAW, CODE, STATUTE AND/OR
                    REGULATION IN OTHER STATE(S)) THAT MIGHT OTHERWISE LIMIT YOUR WAIVER OF SUCH CLAIMS.
                </p>
            </section>
            <br/>
            <section id="intellectualPropertyRights">
                <p><strong>INTELLECTUAL PROPERTY RIGHTS</strong></p>
                <p>
                    The TradeFan Platform, Services, and all content on them—such as text, software, data, graphics,
                    photos, videos, designs, and trademarks (referred to as “<strong>Intellectual Property</strong>”)—are
                    owned by or
                    licensed to TradeFan and protected by U.S. and international laws. TradeFan gives you a limited,
                    non-transferable, revocable, non-exclusive right to use the TradeFan Platform, Services, and
                    Intellectual Property for personal, non-commercial use only. You cannot copy, reproduce, distribute,
                    display, sell, or modify any of this Intellectual Property without TradeFan’s prior written
                    permission.
                </p>
                <p>
                    You are prohibited from reverse-engineering, modifying, or trying to access the source code of the
                    TradeFan Platform or Services. You cannot remove or alter any copyright, trademarks, or other legal
                    notices on the TradeFan Platform. TradeFan reserves all rights not explicitly granted to you and can
                    terminate your use of its Intellectual Property at any time, for any reason. Additionally, you must
                    not interfere with any features that prevent the unauthorized use or copying of TradeFan’s
                    Intellectual Property.
                </p>
            </section>
            <br/>
            <section id="jurisdictionAndGoverningLaw">
                <p><strong>JURISDICTION AND GOVERNING LAW</strong></p>
                <p>
                    If you have any questions, concerns, or complaints related to the TradeFan Platform or Services,
                    please email TradeFan’s customer support at <a
                    href='mailto:support@TradeFan.com'>support@TradeFan.com</a>. You agree to make reasonable,
                    good-faith efforts to resolve any disputes, claims, or controversies with TradeFan through their
                    customer support before pursuing legal action.
                </p>
                <p>
                    The Agreements will be governed by the internal substantive laws of Quebec, Canada, without
                    reference to its conflict of laws principles or any other law that would require applying the laws
                    of a different jurisdiction. The exclusive jurisdiction and venue for any disputes, claims, causes
                    of action, or controversies related to the Agreements, or the use of the TradeFan Platform or
                    Services (“Claims”) will be the courts of competent jurisdiction located in Quebec, Canada (the
                    “Forum”). You irrevocably waive any argument that these courts lack personal jurisdiction or that
                    this Forum is inconvenient or inappropriate. If you initiate a proceeding in a different
                    jurisdiction, you agree that TradeFan will recover from you any attorneys’ fees and expenses
                    reasonably incurred to enforce this Forum agreement. Additionally, you waive any rights to a trial
                    by jury for any Claims.
                </p>
                <p>
                    You agree, to the maximum extent permitted by applicable law, that any and all Claims you have must
                    be commenced within one (1) year from the date the cause of action for such Claim accrues, or you
                    irrevocably waive such Claim and are forever barred from asserting such Claim.
                </p>
            </section>
            <br/>
            <section id="miscellaneous">
                <p><strong>MISCELLANEOUS</strong></p>
                <p>
                    Nothing in the Agreements gives any rights or benefits to third parties, unless specifically stated.
                </p>
                <p>
                    You cannot transfer or assign your rights under the Agreements, including your Account, to anyone
                    else without getting written consent from TradeFan. TradeFan, however, can transfer or assign the
                    Agreements, your Account, or its rights and obligations to any affiliate or third party without your
                    consent or notifying you.
                </p>
                <p>
                    The TradeFan Platform or Services may link to third-party websites, but TradeFan has no control over
                    those sites and isn’t responsible for their content, privacy policies, or practices. TradeFan won’t
                    edit or control content on those sites either. By using the TradeFan Platform or entering Contests,
                    you release the TradeFan Released Parties from any liability related to your use of third-party
                    websites. TradeFan advises you to review the terms and policies of third-party sites you visit, as
                    you use them at your own risk.
                </p>
                <p>
                    There may also be third-party ads on the TradeFan Platform, but TradeFan doesn’t endorse or
                    guarantee any of those products or services. You are responsible for any dealings you have with
                    third-party advertisers, and TradeFan won’t be liable for any losses or damages from those
                    interactions. You agree to indemnify and hold harmless the TradeFan Released Parties from any claims
                    or liabilities that arise from your use of third-party products or services advertised on the
                    TradeFan Platform.
                </p>
                <p>
                    Nothing in the Agreements establishes a partnership or joint venture between you and TradeFan.
                </p>
                <p>
                    Third-party online publishers who refer users to the TradeFan Platform are also not responsible for
                    the TradeFan Platform’s content or services. You also agree to indemnify the TradeFan Released
                    Parties from any liability or claims related to these third-party publishers.
                </p>
                <p>
                    Any waiver of a term must be in writing, and one waiver doesn’t mean future waivers. If any part of
                    the Agreements is deemed invalid, the rest will still be enforceable.
                </p>
                <p>
                    TradeFan can amend the Agreements at any time without notice, and it’s your responsibility to check
                    for updates. Continued use of the TradeFan Platform means you accept any changes. If you disagree
                    with any changes, you must close your account.
                </p>
                <p>
                    TradeFan won’t be liable for not fulfilling any obligations under the Agreements if it’s due to
                    causes beyond its control, such as natural disasters, war, pandemics, or other emergencies.
                </p>
                <p>
                    Lastly, using the Services on your wireless device may result in data charges from your carrier,
                    which you are responsible for.
                </p>
            </section>
            <br/>

            <h1>WHERE CAN YOU PLAY TRADEFAN PICKX?</h1>
            <h2>TradeFan PickX is available in the following US states and Canadian provinces / territories:</h2>
            <br/>
            <PickXProvincesAndTerritories/>
        </div>
    );
}

export default TermsOfUseEn;